<template>
  <a
    v-bind="$attrs"
    @click="$emit('click', $event)"
    :class="[`${linkClass}`]"
    class="font-medium hover:text-primary-500 transition duration-150 ease-in-out"
  >
    <slot></slot>
  </a>
</template>

<script>
export default {
  name: "ALink",

  props: {
    linkClass: { default: "text-primary-600", type: String },
  },

  emits: ["click"],
}
</script>

<style scoped></style>
